import {ChangeDetectionStrategy, Component, HostBinding, inject, input, OnInit} from '@angular/core';
import {WineProduct} from '@core/interfaces/generated/graphql';
import {Observable} from 'rxjs';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {ProductService} from '@core/services/product.service';
import {map, tap} from 'rxjs/operators';
import {ProductWidgetComponent} from '@layout/components/product/product-widget/product-widget.component';
import {AsyncPipe} from '@angular/common';
import {StoryblokBaseComponent} from '../storyblok-base.component';


@Component({
  selector: 'app-storyblok-product-list',
  templateUrl: './storyblok-product-list.component.html',
  styleUrls: ['./storyblok-product-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProductWidgetComponent, AsyncPipe]
})

export class StoryblokProductListComponent extends StoryblokBaseComponent implements OnInit {
  private storyblokStylingService = inject(StoryblokStylingService);
  private productService = inject(ProductService);

  readonly visma_ids = input<string>();

  @HostBinding('style') style: { [styleKey: string]: any };
  @HostBinding('class') class: string[];

  products$: Observable<WineProduct[]>;
  errors: string[];

  ngOnInit() {
    const visma_ids = this.visma_ids();
    if (visma_ids) {
      const productObservable = visma_ids.split(',');
      this.products$ = this.productService.getProducts(productObservable).pipe(
        tap((data: any) => {
          this.errors = data?.reduce((acc: any, item: any) => {
            if (item.error) {
              acc.push(item.error);
            }
            return acc;
          }, []);
        }),
        map((data: any) => data?.map((item: any) => item.product)?.sort((x: any, y: any) => (x.inStock === y.inStock) ? 0 : x.inStock ? -1 : 1))
      );
    }
    this.class = this.getClass() ?? ['d-flex', 'flex-wrap'];
  }

  getClass(): string[] | undefined {
    const classList = this.storyblokStylingService.getClassList(this.generalStyling());
    if (classList.findIndex((d) => d.indexOf('d-') === 0)) {
      return;
    } else {
      classList.push('d-flex', 'flex-wrap');
    }
    return classList;
  }
}
